import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const Wartung: React.FC = () => {
    const styles = useStyles();

    const handleOpenLink = () => {
        // Link to old FHelix system for maintenance
        window.open('https://fhelix.fh-krems.ac.at/studienverwaltung/bewerber/SitePages/ShowStgBewerbungsfristen.aspx', '_blank');
    };

    return (
        <div className={styles.container}>
            <h1>Wartung</h1>
            <p>Wartungs- und Administrations-Tools im FHelix System</p>
            <button onClick={handleOpenLink}>Zum FHelix System</button>
        </div>
    );
};

export default Wartung;
